//
// NOTE THIS IS COMMENTED UNTIL ASYNC_STORAGE V2 IS RELEASED
//

// import AsyncStorageFactory from '@react-native-community/async-storage';
// import WebStorage from '@react-native-community/async-storage-backend-web';

// const localStorage = AsyncStorageFactory.create(new WebStorage('local'));

export default localStorage;